import React, {Component} from 'react';

import {
  Grid,
  Row,
  Col,
} from "react-bootstrap"

const text = global.text

const Header = ({languages = ['no', 'en'], onChangeLanguage}) => (
           <Grid className='header-container'>
            <header>
              <Row>
                <Col xs={8} className='col-8'>
                  <Row className="top_drop">
                    <Col xs={12} className='col-12'>
                      {languages && (
                        <div className='languageSelect'>
                          <a className='choose-lang'>Choose Language</a>
                          <ul>
                            {languages.map((item, i) => {
                              return (
                                <li key={i}>
                                  <a
                                    href='#'
                                    onClick={() => {
                                      onChangeLanguage && onChangeLanguage(item)
                                    }}
                                  >
                                    <span>{text[`language-${item}`]}</span>
                                    <img className='flag' src={`flags/${item}.png`} />
                                  </a>
                                </li>
                              )
                            })}
                          </ul>
                        </div>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} className='col-12'>
                      <a className="pull-left" href="http://www.tatasteeleurope.com/">
                        <img src="images/TataSteel.png" alt="" className="logoText" />
                      </a>
                    </Col>
                  </Row>
                </Col>
                <Col xs={4} className='col-4'>
                  <a className="pull-right " href="http://www.tata.com/">
                    <img className="logo" src="images/TataLogo.png" alt="Tata group logo" />
                  </a>
                </Col>
              </Row>
            </header>
          </Grid>
);


export default Header;



// WEBPACK FOOTER //
// ./Header.js